export enum EmailTemplateType {
    InformationRequestedRetailer = 'InformationRequestedRetailer',
    BindOrder = 'BindOrder',
    PolicyOrder = 'PolicyOrder',
    BinderCorrection = 'BinderCorrection',
    LayerBinder = 'LayerBinder',
    LayerPolicy = 'LayerPolicy',
    MarketDeclined = 'MarketDeclined',
    MarketingReport = 'MarketingReport',
    RfqGeneral = 'RfqGeneral',
    PrimaryMarketing = 'PrimaryMarketing',
    ExcessMarketing = 'ExcessMarketing',
    PolicyCorrection = 'PolicyCorrection',
    RfqAttachmentPoint = 'RfqAttachmentPoint',
    ConceptualTower = 'ConceptualTower',
    SubmissionUpdate = 'SubmissionUpdate',
    NewBusinessProposal = 'NewBusinessProposal',
    RenewalProposal = 'RenewalProposal',
    MissingInformationRequest = 'MissingInformationRequest',
    UserNotification = 'UserNotification',
    EscalationPolicy = 'EscalationPolicy',
    MarketEmailFollowup = 'MarketEmailFollowup',
    CustomerEmailFollowup = 'CustomerEmailFollowup',
    CannotPursue = 'CannotPursue',
    PositiveExpectation = 'PositiveExpectation',
    NewQuote = 'NewQuote',
    SubmissionAssigned = 'SubmissionAssigned',
    SubmissionReceived = 'SubmissionReceived',
    Compose = 'Compose',
    SalesDemoAcknowledgment = 'SalesDemoAcknowledgment',
    SalesDemoProposal = 'SalesDemoProposal',
    SalesDemoDnOAcknowledgment = 'SalesDemoDnOAcknowledgment',
    SalesDemoDnOProposal = 'SalesDemoDnOProposal',
    FastTrackAcknowledgment = 'FastTrackAcknowledgment',
    FastTrackMarketing = 'FastTrackMarketing',
    BorAcknowledgment = 'BorAcknowledgment',
    RenewalSubmissionAssigned = 'RenewalSubmissionAssigned',
    RemarketingUpdate = 'RemarketingUpdate',
    RenewalInformationSolicitation = 'RenewalInformationSolicitation',
    AutomaticFollowup = 'AutomaticFollowup',
}

export interface EmailTemplateMetadata {
    isIncumbent?: boolean;
}
